import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import myContext from "../../../Context/myContext";
import Loader from "../../loader/Loader";
import { deleteDoc, doc } from "firebase/firestore";
import { fireDB } from "../../../firebase/FirebaseConfig";
import toast from "react-hot-toast";

const ProductDetail = () => {
    const context = useContext(myContext);
    const { loading, setLoading, getAllProduct, getAllProductFunction } = context;
    const navigate = useNavigate();
    const deleteProduct = async (id) => {
        setLoading(true)
        try {
            await deleteDoc(doc(fireDB, 'products', id))
            toast.success('Product Deleted successfully')
            getAllProductFunction();
            setLoading(false)
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }
    return (
        <div className="container mt-5">
            {/* Page Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1 className="text-primary font-weight-bold">All Products</h1>
                <Link to={'/addproduct'}>
                    <button className="btn btn-outline-primary">Add Product</button>
                </Link>
            </div>

            {/* Loading Spinner */}
            <div className="d-flex justify-content-center my-5">
                {loading && <Loader />}
            </div>

            {/* Product Table */}
            <div className="table-responsive">
                <table className="table table-bordered table-hover text-center">
                    <thead className="thead-light">
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Image</th>
                            <th scope="col">Title</th>
                            <th scope="col">Short Description</th>
                            <th scope="col">Category</th>
                            <th scope="col">Date</th>
                            <th scope="col">Edit</th>
                            <th scope="col">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {getAllProduct.map((item, index) => {
                            const { id, title, price, category, date, productImageUrl } = item;
                            return (
                                <tr key={id}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <img src={productImageUrl} alt={title} className="img-fluid rounded" style={{ width: '80px' }} />
                                    </td>
                                    <td>{title}</td>
                                    <td>{price}</td>
                                    <td>{category}</td>
                                    <td>{date}</td>
                                    <td>
                                        <button className="btn btn-sm btn-success" onClick={()=>navigate(`/updateproduct/${id}`)}>Edit</button>
                                    </td>
                                    <td>
                                        <button className="btn btn-sm btn-danger" onClick={()=>deleteProduct(id)}>Delete</button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ProductDetail;
